<template>
  <div>
    <h1 class="text-center">Report form</h1>
    <p class="text-center">
      If you want to contact the site administration with a question about the
      questionnaire results, then you can send a report with a comment to the
      administration's mail. Enter your question, click Submit button and you
      will receive an answer to your email
    </p>

    <h3 v-if="sent" class="text-center text-success">Successful sent</h3>
    <div v-else>
      <textarea
        class="col"
        placeholder="Enter your comment..."
        v-model="comment"
      ></textarea>
      <div class="row justify-content-center">
        <div class="col-12 mt-3">
          <app-submit-button
            :btnClass="'d-block mx-auto'"
            :submitAction="sentReport"
            :caption="'Submit'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { HttpHandler } from "@/http/HttpHandler";
import { Group } from "@/entities/questionaire/Group";
import { Answer } from "@/entities/questionaire/answers/Answer";
import { QuestionnaireResult } from "@/entities/questionaire/QuestionnaireResult";
import { SelfcheckReport } from "@/entities/SelfcheckReport";
import AppSubmitButton from "@/components/AppSubmitButton.vue";
import { Treatment } from "@/entities/Treatment";
import store from "@/store/index";

@Component({
  components: {
    AppSubmitButton
  }
})
export default class AppSelfCheckReportForm extends Vue {
  public sent: boolean = false;
  public comment: string = "";

  @Prop()
  branchId!: number;

  @Prop()
  groups!: Group[];

  @Prop()
  answers!: Answer[];

  @Prop()
  treatmentHistory!: Treatment[];

  @Prop()
  result!: QuestionnaireResult;

  @Prop()
  useOnlyMyOpinion!: boolean;

  async sentReport() {
    const httpHandler = new HttpHandler(store);
    await httpHandler.postSelfCheckReport(
      new SelfcheckReport(
        this.branchId,
        this.useOnlyMyOpinion,
        this.answers,
        this.treatmentHistory,
        [],
        this.comment
      )
    );

    this.sent = true;
  }

  reset() {
    if (!this.sent) return;

    this.sent = false;
    this.comment = "";
  }

  @Watch("answers")
  onAnswersChanged() {
    this.reset();
  }
  @Watch("useOnlyMyOpinion")
  onUseOnlyMyOpinionChanged() {
    this.reset();
  }
}
</script>
